import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { sharedStyles } from '../../../utils/Style';

interface OrderDetailsRowTitleProps {
  title: string;
}

const OrderDetailsRowTitle = (props: OrderDetailsRowTitleProps) => {
  return (
    <Typography sx={{ ...sharedStyles.body1, width: 200, fontWeight: 'bold' }}>
      {props.title}
    </Typography>
  );
};

interface OrderDetailsRowProps {
  title: string;
  value: string | ReactNode;
  rightSection?: ReactNode;
}

export const OrderDetailsRow = (props: OrderDetailsRowProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1.5,
        alignItems: 'center',
      }}
    >
      <OrderDetailsRowTitle title={props.title} />
      {typeof props.value === 'string' ? (
        <Typography sx={{ ...sharedStyles.body1 }}>{props.value}</Typography>
      ) : (
        props.value
      )}

      {props.rightSection}
    </Box>
  );
};
